import React from 'react';
import useTranslation from '../../../../../hooks/translation/useTranslation';
import BenefitItem from './components/BenefitItem';

function Benefits({ benefits = [] }) {
  const { currentLanguage } = useTranslation();

  return (
    <div className="hidden lg:flex flex-col gap-[60px]">
      {/* <h1 className="benefits-title">{trans('our_benefits')}</h1> */}
      <div className="grid grid-cols-320 gap-5 lg:gap-[50px]">
        {benefits.map((benefit) => (
          <BenefitItem
            key={benefit.id}
            title={benefit[`title_${currentLanguage}`]}
            url={benefit.url}
            image={benefit.image}
          />
        ))}

      </div>
    </div>
  );
}

export default Benefits;
